import { render, staticRenderFns } from "./Kr2RirekishoEdit.vue?vue&type=template&id=383137a7&scoped=true&"
import script from "./Kr2RirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./Kr2RirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./Kr2RirekishoEdit.vue?vue&type=style&index=0&id=383137a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383137a7",
  null
  
)

export default component.exports